import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core';
import NavBar from './NavBar';
import TopBar from './TopBar';
import useSettings from "../../hooks/useSettings";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        display: 'flex',
        height: '100%',
        overflow: 'hidden',
        width: '100%'
    },
    wrapperVisible: {
        display: 'flex',
        flex: '1 1 auto',
        overflow: 'hidden',
        paddingTop: 64,
        paddingLeft: 256,
        transition: '0.25s'
    },
    wrapperHidden: {
        display: 'flex',
        flex: '1 1 auto',
        overflow: 'hidden',
        paddingTop: 64,
        paddingLeft: 51,
        transition: '0.25s'
    },
    contentContainer: {
        display: 'flex',
        flex: '1 1 auto',
        overflow: 'hidden'
    },
    content: {
        flex: '1 1 auto',
        height: '100%',
        overflow: 'auto'
    }
}));

function DashboardLayout({children}) {
    const classes = useStyles();
    const {settings} = useSettings();
    const [autoHideEnabled, setAutoHideEnabled] = useState(settings.autoHide);

    return (
        <div className={classes.root}>
            <TopBar/>
            <NavBar
                autoHideEnabled={autoHideEnabled}
                setAutoHideEnabled={setAutoHideEnabled}
            />
            <div className={autoHideEnabled ? classes.wrapperHidden : classes.wrapperVisible}>
                <div className={classes.contentContainer}>
                    <div className={classes.content}>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}

DashboardLayout.propTypes = {
    children: PropTypes.any
};

export default DashboardLayout;
